import { IEventrParking, IOptionsWithTypes } from '@eventr/common'

export const getAllPeople = (parking: IEventrParking) => {
    const all: IOptionsWithTypes[] = []
    parking?.cars?.forEach((p) => {
        const { driver, passengers } = p
        if (driver) {
            all.push(...driver)
        }
        if (passengers) {
            all.push(...passengers)
        }
    })
    return all
}
